// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe, arrayOf, enumOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import { hostnameDataStatuses } from "./constants";
import type { PostLandingPagesCustomSubdomainResult } from "./types";

export const isPostLandingPagesCustomSubdomainResult = objectOf<PostLandingPagesCustomSubdomainResult>({
  base_url: string,
  hostname_data: maybe(
    objectOf({
      hostname: string,
      status: enumOf(...hostnameDataStatuses),
      request_initiated_at: number,
      cf_status: maybe(string), // intentionally not more specific just in case CF defines more statuses
      dns_records: maybe(
        arrayOf(
          objectOf({
            type: enumOf("CNAME", "TXT"),
            name: string,
            value: string,
          })
        )
      ),
    }),
    true
  ),
});
